export default __webpack_public_path__ + "static/half-38c7e8e7249383afe8ea4536681cac58.png";